import axios from "axios"
import moment from "moment"
import { read, utils, writeFile } from "xlsx";

const SUCCESS_COLOER = '#37b24d'
const ERROR_COLOR = '#f03e3e'
const NORMAL_COLOR = '#212529'

export default {
  data() {
    return {
      searchTerm: null
    }
  },
  methods: {
    pastDates(date) {
      const beforeToday = new Date(this.getCurrentDate());
      beforeToday.setHours(0, 0, 0, 0);
      return date < beforeToday
    },
    formatTimeStamp(ts) {
      if(!ts) return ''
      let timeStamp = moment(ts).format('YYYY-MM-DD HH:mm')
      return timeStamp
    },
    formatTimeStampToMonth(ts) {
      if(!ts) return '-'
      let timeStamp = moment(ts).format("DD MMM YYYY HH:mm:ss")
      return timeStamp
    },
    formatDate(ts) {
      if(!ts) return '-'
      let timeStamp = moment(ts).format("DD MMM YYYY")
      return timeStamp
    },
    formatCSVCellData(value) {
      if(!value)  return ''
      if(typeof value === 'string') return value.replace(/"/g, '""')
      return value
    },
    formatValue(value) {
      if(!value) return '-'
      return value
    },
    formatBoolean(bool) {
      if(bool) return 'Yes'
      return 'No'
    },
    formatArray(data) {
      if(!data || (data && !data.length)) return ['-']
      if(typeof data === "string")  return JSON.parse(data)
      return data
    },
    getTrimmedString(str) {
      if(!str)  return ""
      return String(str).trim()
    },
    getCurrentTimestamp() {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    },
    getCurrentDate() {
      return moment().format('YYYY-MM-DD')
    },
    convertEmailIdToName(emailid) {
      if(!emailid)  return '-'
      let name = emailid.split('@')
      if(name && name.length) {
        let username = name[0].replace('.', ' ')
        username = username.split(' ').map(i => i.charAt(0).toUpperCase() + i.slice(1))
        name = username.join(' ')
        return name
      } else {
        return emailid
      }
    },
    getDataPoint(value) {
      if(!value)  return 0
      return value.datapoint ? value.datapoint : 0
    },
    convertSnakeCaseToWords(word) {
      if(!word) return '-'
      return word.split('_').map(w => w.slice(0,1).toUpperCase() + w.slice(1)).join(' ')
    },
    dateWithAmPm(date) {
      if(!date) return "-"
      return moment(date).format("DD MMM YYYY hh:mm A")
    },
    getDownloadedLink(key) {
      axios({
        method: 'GET',
        url: `/files/s3/getPresignedURL?fileKey=${key}`
      })
      .then(async result => {
        if(result.data.status) {
          this.sweetAlertSnackbar(result.data.message, 'success')
          window.open(result.data.data, '_blank')
        } else {
          this.sweetAlertSnackbar(result.data.message, 'error')
        }
      })
      .catch(e => {
        this.displayError(e)
      })
    },
    async getPresignUrl(key) {
      try {
        let result = await axios({
          method: 'GET',
          url: `/files/s3/getPresignedURL?fileKey=${key}`
        })
        if(result.data.status) {
          return result.data.data
        } else {
          this.sweetAlertSnackbar(result.data.message, 'error')
          return ""
        }
      } catch(e) {
        this.displayError(e)
        return ""
      }
    },
    downLoadFile(data, fileName) {
      const anchorElement = document.createElement('a');

      document.body.appendChild(anchorElement);

      anchorElement.style.display = 'none';

      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      })

      const url = window.URL.createObjectURL(blob);

      anchorElement.href = url;
      anchorElement.download = fileName;
      anchorElement.click();

      window.URL.revokeObjectURL(url);
    },
    getTemplateFile(key) {
      axios({
        method: 'GET',
        url: `/files/getTemplateFile?fileKey=${key}`,
        responseType: 'blob'
      })
      .then(async result => {
        if(result.data) {
          this.downLoadFile(result.data, key + '_template')
        } else {
          this.sweetAlertSnackbar(result.data.message, 'error')
        }
      })
      .catch(e => {
        this.displayError(e)
      })
    },
    notifyListingSuccess(message, type) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-start',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        background: NORMAL_COLOR,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      });
      Toast.fire({
        icon: type,
        title: message,
      })
    },
    sweetAlertSnackbar(message, type, end='bottom') {
      const Toast = Swal.mixin({
        toast: true,
        position: end,
        showConfirmButton: false,
        timer: !type ? 4000 : 8000,
        timerProgressBar: true,
        background: type === 'success' ? SUCCESS_COLOER : type === 'error' ? ERROR_COLOR : NORMAL_COLOR,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      });
      Toast.fire({
        icon: type,
        title: message,
      })
    },
    displayError(e) {
      let response = e ? e.response : e
      this.isLoading = false
      let message = 'Something went wrong! ' + e
      if(response?.data && (response.data.message || response.data.msg)) message = `${response.data.message}`
      this.sweetAlertSnackbar(message, 'error')
      if(response?.data.errorCode == 101) {
        this.sweetAlertSnackbar(message, 'error')
        // window.location.href = "/#/login";
        localStorage.removeItem('reloaded');
        localStorage.removeItem('userdata');
        localStorage.removeItem('token');
        localStorage.removeItem('check');
        localStorage.removeItem('pagefeatures');
        localStorage.removeItem('sidebar');
        localStorage.removeItem('travel');
        this.$router.push('/login');

        // Swal.fire({
        //   title: "Session Expired!",
        //   text: message,
        //   icon: 'info',
        //   customClass: {
        //     confirmButton: "btn btn-primary",
        //   },
        //   buttonsStyling: !1,
        // })
        // .then(function() {
        //   window.location.href = "/#/login";
        // })
      }
    },
    disableFutureDates(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    disabledPastDates(date) {
      if(!this.search.from_date) return false
      let dayBefore = moment(this.search.from_date).format('YYYY-MM-DD');
      const beforeToday = new Date(dayBefore);
      beforeToday.setHours(0, 0, 0, 0);
      return date < beforeToday; 
    },
    convertMinutesToTime(timestamp1, timestamp2) {
      if(!timestamp1 || !timestamp2) return "-"
      const date1 = new Date(timestamp1);
      const date2 = new Date(timestamp2);
      const timeDifferenceMs = date2 - date1;
      const hours = Math.abs(Math.floor(timeDifferenceMs / (1000 * 60 * 60)));
      const minutes = Math.abs(Math.floor((timeDifferenceMs % (1000 * 60 * 60)) / (1000 * 60)));
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    convertMinutesToTime2(totalMinutes) {
      if(!totalMinutes && totalMinutes != 0) return "-"
      totalMinutes = Math.abs(totalMinutes)
      let hours = Math.floor(totalMinutes / 60)
      let minutes = Math.round(totalMinutes % 60)
      // Add leading zeros if needed
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let s = hours + ':' + minutes;
      return s;

    },
    convertMinutesToTime3(totalMinutes) {
      if(!totalMinutes && totalMinutes != 0) return "-"
      totalMinutes = Math.abs(totalMinutes)
      let hours = Math.floor(totalMinutes / 60)
      let minutes = Math.round(totalMinutes % 60)
      // Add leading zeros if needed
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      return `${hours} h ${minutes} m`;
    },
    getTimeDiffInMinutes(date1, date2) {
      if(!date1 || !date2) return "-"
      var start = new Date(date1);
      var final = new Date(date2);
      var diffMs = (final - start); // milliseconds between now & Christmas
      var diffDays = Math.floor(diffMs / 86400000); // days
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
      var diffMins = Math.floor((diffMs / 1000) / 60); // minutes
      return Math.abs(diffMins)
    },
    roundNumber(number) {
      if(!number) return 0
      return Math.round(Number(number) * 100) / 100
    },
    convertToInteger(number) {
      if(!number) return 0
      return Math.ceil(number)
    },
    getColumnList(table) {
      let columns = {
        warehouse_master: [
          { id: 'warehouse_id', label: 'Warehouse ID' },
          { id: 'warehouse_name', label: 'Warehouse Name' },
          { id: 'city', label: 'city' },
          { id: 'location', label: 'location' },
          { id: 'state', label: 'State' },
          { id: 'pincode', label: 'pincode' },
          { id: 'latitude', label: 'Latitude' },
          { id: 'longitude', label: 'Longitude' },
        ],
        vehicle_registration_master: [
          { id: 'vehicle_id', label: 'Vehicle ID' },
          { id: 'vehicle_type', label: 'Vehicle Type' },
          { id: 'vehicle_size', label: 'Vehicle Size' },
          { id: 'vehicle_tonnage', label: 'Vehicle Capacity (In Ton)' },
          { id: 'vendor_id', label: 'Vendor' },
          { id: 'vehicle_number_plate', label: 'Vehicle Number' },
          { id: 'vehicle_rc_no', label: 'Vehicle RC No.' },
          { id: 'vehicle_documents', label: 'Vehicle Documents' },
          { id: 'vehicle_condition', label: 'Vehicle Condition' },
          { id: 'vehicle_attached_to', label: 'Vehicle Attached To' },
          { id: 'vehicle_transaction_type', label: 'Vehicle Transaction Type' },
          { id: 'last_maintenance_date', label: 'Last maintenance Date',
            format: (date) => {
              if(!date || moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
                return null
              }
              let formattedDate = moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            }
          },
          { id: 'next_maintenance_due_date', label: 'Next maintenance due date',
            format: (date) => {
              if(!date || moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
                return null
              }
              let formattedDate = moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            } 
          },
        ],
        gate_master: [
          { id: 'gate_id', label: 'Gate ID' },
          { id: 'gate_name', label: 'gatename' },
          { id: 'gate_type', label: 'gatetype' },
          { id: 'operational_hours', label: 'OperationalHours' },
          { id: 'usage_type', label: 'UsageType' },
        ],
        dock_master: [
          { id: 'dock_id', label: 'Dock ID' },
          { id: 'dock_name', label: 'DOCK NAME' },
          { id: 'dock_type', label: 'DOCK TYPE' },
          { id: 'dock_number', label: 'DOCK NUMBER' },
          { id: 'warehouse_id', label: 'WAREHOUSE' },
          { id: 'dock_location', label: 'DOCK LOCATION' },
          { id: 'max_capacity', label: 'MAX CAPACITY' },
          { id: 'current_usage', label: 'CURRENT USAGE' },
        ],
        zone_master: [
          { id: 'zone_id', label: 'Zone ID' },
          { id: 'zone_name', label: 'Zone Name' },
          { id: 'zone_type', label: 'Zone Type' },
          { id: 'zone_number', label: 'Zone Number' },
          { id: 'warehouse_id', label: 'Warehouse id' },
          { id: 'zone_location', label: 'Zone Location' },
          { id: 'max_capacity', label: 'Max Capacity' },
          { id: 'current_usage', label: 'Current Usage' },
          { id: 'safety_information', label: 'Safety Information' },
        ],
        vendor_master: [
          { id: 'vendor_id', label: 'Vendor ID' },
          { id: 'vendor_name', label: 'Vendor Name' },
          { id: 'contact_person', label: 'Contact Person' },
          { id: 'contact_number', label: 'Contact Number' },
          { id: 'email', label: 'Email' },
          { id: 'address', label: 'Address' },
          { id: 'country', label: 'Country' },
          { id: 'state', label: 'State' },
          { id: 'city', label: 'City' },
          { id: 'pincode', label: 'Pincode' },
          { id: 'vendor_rating', label: 'Vendor Rating' },
        ],
        shipment_booking_master: [
          { id: 'docket_no', label: 'Docket No' },
          { id: 'shipment_awb', label: 'Package No.' },
          { id: 'booking_ou', label: 'Booking OU' },
          { id: 'delivery_ou', label: 'Delivery OU' },
          { id: 'shipment_actual_weight', label: 'Shipment Actual Weight' },
          { id: 'shipment_volumetric_weight', label: 'Shipment Volumetric Weight' },
          { id: 'shipment_dimensions', label: 'Shipment Dimensions' },
          { id: 'shipment_category', label: 'Shipment Category' },
          { id: 'shipment_subtype', label: 'Shipment Subtype' },
          { id: 'charges', label: 'Charges' },
          { id: 'tax', label: 'Tax' },
          { id: 'delivery_city', label: 'Delivery City' },
          { id: 'delivery_pincode', label: 'Delivery Pincode' },
          { id: 'delivery_state', label: 'Delivery State' },
          { id: 'route_type', label: 'Route Type' },
          { id: 'shipment_status', label: 'Shipment Status' },
          { id: 'shipment_delivery_datetime', label: 'Shipment Delivery Datetime',
            format: (date) => {
              if(!date || moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
                return null
              }
              let formattedDate = moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            }
          },
          { id: 'no_of_pkg_in_docket', label: 'No of Pkg In Docket' },
          { id: 'no_of_pkg_in_vehicle', label: 'No of Pkg In vehicle' },
        ],
        route_details: [
          { id: 'route_number', label: 'Route No' },
          { id: 'route_path', label: 'Route Path' },
          { id: 'schedule_departure', label: 'Schedule departure',
            format: (date) => {
              if(!date) return null
              if(typeof date === 'string') return date
              let formattedDate = moment(date, 'DD-MM-YYYY HH:mm:ss').format('HH:mm:ss')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            }
          },
        ],
        vehicle_route_controlling: [
          { id: 'vehicle_number_plate', label: 'Veh Reg No' },
          { id: 'route_number', label: 'Route No' },
          { id: 'warehouse_name', label: 'Contr Ou' },
          { id: 'route_status', label: 'Route Status' },
          { id: 'zone', label: 'Zone' },
          { id: 'edc', label: 'Edc' },
          { id: 'control_number', label: 'Contr No' },
          { id: 'flat_rate', label: 'Flat Rate' },
          { id: 'rate_km', label: 'Rate/KM' },
          { id: 'origin', label: 'Origin' },
          { id: 'destination', label: 'Destn' },
          { id: 'route_category', label: 'Route Catg' },
          { id: 'vehicle_make', label: 'Veh Make' },
          { id: 'vehicle_model', label: 'Veh Model' },
          { id: 'vehicle_payload', label: 'Veh Payload' },
          { id: 'contract_end_date', label: 'Contract End Date',
            format: (date) => {
              if(!date || moment(date, 'DD-MMM-YYYY').format('DD-MM-YYYY') === 'Invalid date') {
                return null
              }
              let formattedDate = moment(date, 'DD-MM-YYYY').add(1, "days").format('YYYY-MM-DD')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            }
          },
          { id: 'v_l', label: 'V_L' },
          { id: 'v_b', label: 'V_B' },
          { id: 'v_h', label: 'V_H' },
          { id: 'last_trip_number', label: 'Last Trip No' },
          { id: 'last_trip_date', label: 'Last trip DATE',
            format: (date) => {
              if(!date || moment(date, 'DD-MMM-YYYY').format('DD-MM-YYYY') === 'Invalid date') {
                return null
              }
              let formattedDate = moment(date, 'DD-MM-YYYY').add(1, "days").format('YYYY-MM-DD')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            }
          },
          { id: 'mobile_number', label: 'Mobile No' },
          { id: 'email_id', label: 'Email Id' },
          { id: 'vehicle_on_road_date', label: 'Veh Onroad Date', 
            format: (date) => {
              if(!date || moment(date, 'DD-MMM-YYYY').format('DD-MM-YYYY') === 'Invalid date') {
                return null
              }
              let formattedDate = moment(date, 'DD-MM-YYYY').add(1, "days").format('YYYY-MM-DD')
              if(formattedDate === 'Invalid date') {
                return null
              }
              return formattedDate
            }
          },
          { id: 'age_of_vehicle', label: 'Age Of Veh' },
          { id: 'distance', label: 'Dis' },
          { id: 'r_type', label: 'R_Type' },
          { id: 'vh_type', label: 'VH_Typ' },
        ],
        map_dock_to_sector: [
          { id: 'dock_name', label: 'Dock Name' },
          { id: 'sector_name', label: 'Sector Name' },
        ],
        ou_to_sector: [
          { id: 'ou', label: 'OU' },
          { id: 'sector_name', label: 'Sector Name' },
        ],
        scenario: [
          { id: "scenario", label: "Scenario Title" },
          { id: "description", label: "Scenario Description" },
          { id: "is_level", label: "Level Applicable" },
        ],
        stc_contacts: [
          { id: "zone", label: "ZONE" },
          { id: "edc", label: "EDC" },
          { id: "edc_contact", label: "EDC Contact Number" },
          { id: "stc", label: "STC" },
          { id: "stc_manager", label: "STC Manager" },
          { id: "stc_contact", label: "STC Contact Number" },
          { id: "network_manager", label: "Network Manager" },
          { id: "network_contact", label: "Network Contact Number" },
          { id: "edch", label: "EDCH" },
          { id: "edch_contact", label: "EDCH Contact Number" },
        ],
        subscribers: [
          { id: "contact_name", label: "Contact Name" },
          { id: "contact_number", label: "Contact Number" },
          { id: "position", label: "Position" },
        ],
      }
      return columns[table]
    },
    exportData(table, fileName, orderBy="", payload={}) {
      let url = `/data/${table}/exports`
      if(orderBy) {
        url += `?orderBy=${orderBy}`
      }
      this.makeRequest("POST", url, payload)
        .then(result => {
          const ws = utils.json_to_sheet(result.data);
          /* create workbook and append worksheet */
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, "Data");
          /* export to XLSX */
          writeFile(wb, `${fileName}${moment().format('dd_mm_yy_hh_mm')}.csv`);
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    exportJsonData(data, fileName="error") {
      const ws = utils.json_to_sheet(data);
      /* create workbook and append worksheet */
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");
      /* export to XLSX */
      writeFile(wb, `${fileName}_${moment().format('hh_mm_ss')}.csv`);
    },
    degToRad(degrees) {
      return degrees * (Math.PI / 180);
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the Earth in kilometers
      const dLat = this.degToRad(lat2 - lat1);
      const dLon = this.degToRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.degToRad(lat1)) * Math.cos(this.degToRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in kilometers
      return distance;
    },
    getTemplate(headers, fileName) {
      const ws = utils.json_to_sheet(headers);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${fileName}_${moment().format("DD MMM YYYY HH:mm:ss")}.csv`
      );
    },
  }
}